var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"29f303505adede4b75a189d1c297d0261ea28600"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["frontend-next@tutorspot"]={id:"29f303505adede4b75a189d1c297d0261ea28600"};
      